import { Stack } from '@mui/material';
import { Cell, Text } from '@telegram-apps/telegram-ui';
import { CommonIcon } from '../../common/CommonIcon';
import { CustomSection } from '../../common/CustomSection';
import { useFeatureFlag } from '../../../contexts/FeatureFlagContext';
import { useTranslation } from 'react-i18next';

export type QuestHeaderCompletedProps = {
    onClick: () => void;
    totalReward: number;
};

export const QuestHeaderCompleted = ({ onClick, totalReward }: QuestHeaderCompletedProps) => {
    const showReward = useFeatureFlag('rewards');
    const { t } = useTranslation('common');
    return (
    <Stack direction="row" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <CustomSection onClick={onClick}>
            <Cell
                style={{
                    '--tgui--cell--middle--padding': '6px 0 10px 0',
                    gap: '8px',
                    paddingLeft: '8px',
                    paddingRight: '8px',
                    border: '1px solid var(--tgui--link_color)'
                } as any}
                before={<CommonIcon icon="emoji_events" type="filled" size={22} color="var(--tgui--link_color)" />}
                subtitle={
                    <Text weight="3" style={{ fontSize: '12px', lineHeight: '12px' }}>
                        {showReward ? t('quest.goals.rewardEarned') : t('quest.goals.tapToContinue')}
                    </Text>
                }
                after={showReward ? (
                    <Stack justifyContent="center" alignItems="center" gap="2px">
                        <CommonIcon icon="paid" type="filled" size={16} color="var(--tgui--link_color)" />
                        <Text style={{ fontSize: '10px', lineHeight: '10px', color: 'var(--tgui--link_color)' }}>
                            +{totalReward}
                        </Text>
                    </Stack>
                ) : (
                    <Stack justifyContent="center" alignItems="center" minWidth={28}>
                        <CommonIcon icon="chevron_right" type="filled" size={20} color="var(--tgui--hint_color)" />
                    </Stack>
                )}
            >
                <Text weight="2" style={{ fontSize: '14px', lineHeight: '14px' }}>
                    {t('quest.goals.completed')}
                </Text>
            </Cell>
        </CustomSection>
    </Stack>
    );
};
